import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogData, DialogService, LanguageService, ScanResult, ScanService } from '@definitiv-packages/angular-dba-library';
import { CreateSafetyPointComponent, ProjectLanguage, SafetyPointModelView, SafetyPointViewService, ScanPrefix } from '../../../../../roofsafetymanagement-library/src/public-api';
import { ShowSafetyPointComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/show-safetypoint/show-safetypoint.component';

@Component({
  selector: 'app-safetypoint-suche',
  templateUrl: './safetypoint-suche.component.html',
  styleUrls: ['./safetypoint-suche.component.scss'],
  standalone: false
})
export class SafetypointSucheComponent implements OnInit, OnDestroy {
  @Output() public safetypointSelected: EventEmitter<SafetyPointModelView> = new EventEmitter();
  public searchInput: string = '';
  public safetypointList: SafetyPointModelView[] = [];
  public language: ProjectLanguage;
  public documentList: Document[] = [];

  public saveDebitorid: number = 0;

  private completeSafetypointList: SafetyPointModelView[] = [];
  private scanSubscription: Subscription;

  constructor(

    private safetypointService: SafetyPointViewService,
    private languageService: LanguageService,
    private scanService: ScanService,
    private dialogService: DialogService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.language = this.languageService.getLanguageAsSetter();
    this.scanSubscription = this.scanService.scan.subscribe(result => this.handleScan(result));
  }

  public async ngOnInit(): Promise<void> {
    this.completeSafetypointList = await this.safetypointService.getList();
   
    this.safetypointList = this.completeSafetypointList;
  }

  public ngOnDestroy(): void {
    this.scanSubscription.unsubscribe();
  }

  public handleSafetypointClick(safetypoint: SafetyPointModelView): void {
    this.safetypointSelected.emit(safetypoint);
  }

  public handleScan(result: ScanResult): void {
    this.searchInput = '';

    if (result.Prefix === ScanPrefix.SafetyPointId) this.handleSafetypointIdScan(parseInt(result.Text));
    else if (!result.Prefix) this.handleNumberScan(result.Text);
  }

  public search(): void {
    if (this.completeSafetypointList?.length > 0) this.searchLocal();
    else this.searchServer();
  }

  public handleSearchInputChange(): void {
    if (this.completeSafetypointList?.length > 0) this.searchLocal();
  }

  public handleInfoButtonClick(event: MouseEvent, saftypoint: SafetyPointModelView): void {
    event.stopPropagation();

    this.dialog.open(ShowSafetyPointComponent, { data: saftypoint }).afterClosed().subscribe((result) => {
      
    });
    
  }

  public handleEditButtonClick(event: MouseEvent, saftypoint: SafetyPointModelView): void {
    event.stopPropagation();

    const data: DialogData<SafetyPointModelView> = {
      data: saftypoint,
      mode: 'edit'
    };

    this.dialog.open(CreateSafetyPointComponent, { data: data }).afterClosed().subscribe((result) => {
      if (result) {
        this.completeSafetypointList.push(result);
        this.safetypointList = this.completeSafetypointList;
      }
    });

    
  }

  private searchLocal(): void {
    var input = this.searchInput.toLowerCase();

    const terms = input
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(t => t.length > 0);


    this.safetypointList = this.completeSafetypointList.filter(item => {
      const values = [
        item.Bezeichnung,
        item.ObjektBezeichnung,
        item.StandortBezeichnung,
        item.Debitorname,
        item.RoofareaBezeichnung,
        item.SicherungssystemBezeichnung
      ]
        .filter((v): v is string => !!v)
        .map(v => v.toLowerCase());

      return terms.every(term =>
        values.some(value => value.includes(term))
      );
    });


  }

  private async searchServer(): Promise<void> {
    this.safetypointList = await this.safetypointService.search(this.searchInput);
  }

  private handleSafetypointIdScan(safetypointId: number): void {
    if (this.completeSafetypointList) {
      var article = this.completeSafetypointList.find(x => x.SafetyPointId == safetypointId);
      if (article) this.safetypointSelected.emit(article);
      else this.openErrorDialog();
    } else {
      this.safetypointService.get(safetypointId).then(safetypoint => {
        if (safetypoint) this.safetypointSelected.emit(article);
        else this.openErrorDialog();
      });
    }
  }

  private async handleNumberScan(input: string): Promise<void> {
    if (this.completeSafetypointList) {
      var safetypoint = this.completeSafetypointList.find(x => x.SafetyPointId.toString() == input);
      if (safetypoint) this.safetypointSelected.emit(safetypoint);
    } else {
      // var list = await this.safetypointService.getFilteredList({ SafetyPointId: input });
      // if (list.length > 0) this.safetypointSelected.emit(list[0]);
    }
  }

  private openErrorDialog(): void {
    this.dialogService.showMessageDialog(this.languageService.getText(this.language.Fehler), this.languageService.getText(this.language.SafetypointNotExist));
  }


  public opencreateDialog(): void {

    const data: DialogData<SafetyPointModelView> = {
      data: null,
      mode: 'create'
    };

    this.dialog.open(CreateSafetyPointComponent, { data: data }).afterClosed().subscribe((result) => {
      if (result) {
        this.completeSafetypointList.push(result);
        this.safetypointList = this.completeSafetypointList;
      }
    });
  }

  isValidUrl(url: string | null | undefined): boolean {
    if (!url) {
      return false;
    }

    try {
      const parsed = new URL(url);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  }
}
